import { useTheme } from "../../contexts/ThemeContext"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const themeContext = useTheme()
  // Default to dark theme for ZuperBooks UI
  const theme = themeContext?.theme || "dark"

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      richColors
      closeButton
      toastOptions={{
        duration: 4000,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#1a2744] group-[.toaster]:text-white group-[.toaster]:border-[#2a3f5f] group-[.toaster]:shadow-xl",
          description: "group-[.toast]:text-gray-300",
          actionButton:
            "group-[.toast]:bg-emerald-500 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-gray-600 group-[.toast]:text-gray-200",
          success: "group-[.toaster]:border-emerald-500/50",
          error: "group-[.toaster]:border-red-500/50",
          warning: "group-[.toaster]:border-yellow-500/50",
          info: "group-[.toaster]:border-blue-500/50",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
